import Axios from "../../config/axios";
import { getCurrentLanguage } from "../../helpers/Utils";
import { saveAs } from "file-saver";
import { getDate1 } from "../../constants/defaultValues";

class SimService {
  getSimDistribution = async (paramdata) => {
    let currentDate = getDate1(new Date());
    paramdata = {
      ...paramdata,
      language: getCurrentLanguage(),
    };

    let params = {
      params: paramdata,
    };

    if (paramdata?.isExcel || paramdata?.isPdf) {
      params.responseType = "arraybuffer";
    }
    return await Axios.get("/get-invoice-sim-distribution", params)
      .then(function (response) {
        const { data: data_1 } = response;
        if (paramdata?.isExcel || paramdata?.isPdf) {
          const fileName = "Sim Distrubuted List " + currentDate;
          const blob = new Blob([data_1], {
            type: response?.headers["content-type"],
          });
          saveAs(blob, fileName);
        } else {
          return data_1;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getDspUser1 = async (data) => {
    return await Axios.get("/get-user-by-parent")
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getSimUserDistribution = () => {
    return Axios.get("get-sim-user-distribution")
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // getSimStock = (requestData) => {
  //   return Axios.get("/get-sim-stock", {
  //     params: requestData,
  //   })
  //     .then(function (response) {
  //       const { data } = response;
  //       return data;
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  getSimInventory = (data) => {
    return Axios.get("/get-sim-inventory", {
      params: data,
    })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getUserSimStock = () => {
    return Axios.get("/get-user-sim-stock")
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  manageSimInventory = (data) => {
    return Axios.post("/manage-sim-inventory", data)
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getUserTypes = (requestData) => {
    return Axios.post("/get-usertype-list", requestData)
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  saveInvoiceSim = (data) => {
    return Axios.post("/manage-sim-sale-request", data)
      .then((response) => {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
  checkSimInvoice = (data) => {
    return Axios.get("/verify-sim-request", {
      params: data,
    })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getSellingPrice = (data) => {
    return Axios.get("/get-sim-selling-price", {
      params: data,
    })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getSimSearch = (data) => {
    return Axios.get("/get-sim-search", {
      params: data,
    })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
  getIccid = (data) => {
    return Axios.get("/get-sim-deliverynote-generation", {
      params: data,
    })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
  manageBulkSimInventory = (data) => {
    return Axios.get("/bulk-sim-inventory", {
      params: data,
    })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
  getSimCount = (data) => {
    return Axios.get("/iccid-count", {
      params: data,
    })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }
  checkMultiSimInvoice = (data) => {
    return Axios.get("/verify-multisim-request", {
      params: data,
    })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  }

   manageBulkMultiSimInventory = (data) => {
    return Axios.get("/bulk-multisim-inventory", {
      params: data,
    })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
getmultiSellingPrice= (data) => {
    return Axios.get("/get-multisim-selling-price", {
      params: data,
    })
      .then(function (response) {
        const { data } = response;
        return data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export default new SimService();
